"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigationWarningService = void 0;
var NavigationWarningService = /** @class */ (function () {
    function NavigationWarningService() {
        this.isCallActive = false;
        this.isSPA = false;
        this.warningOptions = null;
        this.originalBeforeUnloadHandler = null;
        this.detectSPA();
        this.setupNavigationListeners();
    }
    NavigationWarningService.getInstance = function () {
        if (!NavigationWarningService.instance) {
            NavigationWarningService.instance = new NavigationWarningService();
        }
        return NavigationWarningService.instance;
    };
    NavigationWarningService.prototype.detectSPA = function () {
        // Check if the site is likely an SPA by looking for common indicators
        var hasHistoryAPI = 'pushState' in window.history;
        var hasRouter = !!(document.querySelector('[data-router]') ||
            document.querySelector('[data-route]') ||
            document.querySelector('[ng-app]') || // Angular
            document.querySelector('[data-reactroot]') || // React
            document.querySelector('[data-vue-app]')); // Vue
        this.isSPA = hasHistoryAPI && (hasRouter || window.location.hash.includes('#/'));
        console.log('Navigation Warning Service: Site detected as', this.isSPA ? 'SPA' : 'non-SPA');
    };
    NavigationWarningService.prototype.setupNavigationListeners = function () {
        // Listen for clicks on links
        document.addEventListener('click', this.handleLinkClick.bind(this));
        // Listen for form submissions
        document.addEventListener('submit', this.handleFormSubmit.bind(this));
        // Listen for beforeunload events (page refresh, close tab, etc.)
        this.originalBeforeUnloadHandler = window.onbeforeunload;
        window.addEventListener('beforeunload', this.handleBeforeUnload.bind(this));
    };
    NavigationWarningService.prototype.handleLinkClick = function (event) {
        var target = event.target;
        var link = target.closest('a');
        if (!link || !this.isCallActive || this.isSPA) {
            return;
        }
        var href = link.getAttribute('href');
        if (!href || href.startsWith('#') || href.startsWith('javascript:') || href.startsWith('mailto:') || href.startsWith('tel:')) {
            return;
        }
        // Check if it's an external link or different page
        var targetUrl = new URL(href, window.location.origin);
        if (targetUrl.origin !== window.location.origin || targetUrl.pathname !== window.location.pathname) {
            event.preventDefault();
            this.showNavigationWarning(targetUrl.href);
        }
    };
    NavigationWarningService.prototype.handleFormSubmit = function (event) {
        if (!this.isCallActive || this.isSPA) {
            return;
        }
        var form = event.target;
        var action = form.getAttribute('action');
        if (action) {
            var targetUrl = new URL(action, window.location.origin);
            if (targetUrl.origin !== window.location.origin || targetUrl.pathname !== window.location.pathname) {
                event.preventDefault();
                this.showNavigationWarning(targetUrl.href);
            }
        }
    };
    NavigationWarningService.prototype.handleBeforeUnload = function (event) {
        if (this.isCallActive && !this.isSPA) {
            event.preventDefault();
            event.returnValue = 'You have an active call. Are you sure you want to leave?';
            return event.returnValue;
        }
    };
    NavigationWarningService.prototype.showNavigationWarning = function (targetUrl) {
        if (!this.warningOptions) {
            console.warn('Navigation warning options not set');
            return;
        }
        // Create and show the warning modal
        this.createWarningModal(targetUrl);
    };
    NavigationWarningService.prototype.createWarningModal = function (targetUrl) {
        var _this = this;
        // Remove existing modal if any
        var existingModal = document.getElementById('navigation-warning-modal');
        if (existingModal) {
            existingModal.remove();
        }
        var modal = document.createElement('div');
        modal.id = 'navigation-warning-modal';
        modal.style.cssText = "\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background: rgba(0, 0, 0, 0.7);\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      z-index: 10000;\n      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    ";
        var modalContent = document.createElement('div');
        modalContent.style.cssText = "\n      background: white;\n      padding: 2rem;\n      border-radius: 12px;\n      max-width: 500px;\n      width: 90%;\n      text-align: center;\n      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n    ";
        var title = document.createElement('h3');
        title.textContent = 'Active Call Warning';
        title.style.cssText = "\n      margin: 0 0 1rem 0;\n      color: #dc2626;\n      font-size: 1.5rem;\n      font-weight: 600;\n    ";
        var message = document.createElement('p');
        message.textContent = "You have an active call that will end if you navigate away from this page. Would you like to open the new page in a new tab to keep your call active?";
        message.style.cssText = "\n      margin: 0 0 1.5rem 0;\n      color: #374151;\n      line-height: 1.6;\n      font-size: 1rem;\n    ";
        var targetInfo = document.createElement('p');
        targetInfo.textContent = "Destination: ".concat(targetUrl);
        targetInfo.style.cssText = "\n      margin: 0 0 1.5rem 0;\n      color: #6b7280;\n      font-size: 0.875rem;\n      word-break: break-all;\n    ";
        var buttonContainer = document.createElement('div');
        buttonContainer.style.cssText = "\n      display: flex;\n      gap: 1rem;\n      justify-content: center;\n      flex-wrap: wrap;\n    ";
        var newTabButton = document.createElement('button');
        newTabButton.textContent = 'Open in New Tab';
        newTabButton.style.cssText = "\n      background: #2563eb;\n      color: white;\n      border: none;\n      padding: 0.75rem 1.5rem;\n      border-radius: 8px;\n      cursor: pointer;\n      font-size: 1rem;\n      font-weight: 500;\n      transition: background-color 0.2s;\n    ";
        newTabButton.onmouseover = function () { return newTabButton.style.background = '#1d4ed8'; };
        newTabButton.onmouseout = function () { return newTabButton.style.background = '#2563eb'; };
        newTabButton.onclick = function () {
            var _a;
            (_a = _this.warningOptions) === null || _a === void 0 ? void 0 : _a.onConfirmNavigate(targetUrl);
            modal.remove();
        };
        var leaveButton = document.createElement('button');
        leaveButton.textContent = 'Leave Page (End Call)';
        leaveButton.style.cssText = "\n      background: #dc2626;\n      color: white;\n      border: none;\n      padding: 0.75rem 1.5rem;\n      border-radius: 8px;\n      cursor: pointer;\n      font-size: 1rem;\n      font-weight: 500;\n      transition: background-color 0.2s;\n    ";
        leaveButton.onmouseover = function () { return leaveButton.style.background = '#b91c1c'; };
        leaveButton.onmouseout = function () { return leaveButton.style.background = '#dc2626'; };
        leaveButton.onclick = function () {
            window.location.href = targetUrl;
        };
        var cancelButton = document.createElement('button');
        cancelButton.textContent = 'Cancel';
        cancelButton.style.cssText = "\n      background: #6b7280;\n      color: white;\n      border: none;\n      padding: 0.75rem 1.5rem;\n      border-radius: 8px;\n      cursor: pointer;\n      font-size: 1rem;\n      font-weight: 500;\n      transition: background-color 0.2s;\n    ";
        cancelButton.onmouseover = function () { return cancelButton.style.background = '#4b5563'; };
        cancelButton.onmouseout = function () { return cancelButton.style.background = '#6b7280'; };
        cancelButton.onclick = function () {
            var _a;
            (_a = _this.warningOptions) === null || _a === void 0 ? void 0 : _a.onCancelNavigate();
            modal.remove();
        };
        buttonContainer.appendChild(newTabButton);
        buttonContainer.appendChild(leaveButton);
        buttonContainer.appendChild(cancelButton);
        modalContent.appendChild(title);
        modalContent.appendChild(message);
        modalContent.appendChild(targetInfo);
        modalContent.appendChild(buttonContainer);
        modal.appendChild(modalContent);
        document.body.appendChild(modal);
        // Close modal when clicking outside
        modal.onclick = function (e) {
            var _a;
            if (e.target === modal) {
                (_a = _this.warningOptions) === null || _a === void 0 ? void 0 : _a.onCancelNavigate();
                modal.remove();
            }
        };
    };
    NavigationWarningService.prototype.setCallActive = function (active) {
        this.isCallActive = active;
        console.log('Navigation Warning Service: Call active state set to', active);
    };
    NavigationWarningService.prototype.setWarningOptions = function (options) {
        this.warningOptions = options;
    };
    NavigationWarningService.prototype.getIsSPA = function () {
        return this.isSPA;
    };
    NavigationWarningService.prototype.getIsCallActive = function () {
        return this.isCallActive;
    };
    NavigationWarningService.prototype.cleanup = function () {
        // Remove event listeners
        document.removeEventListener('click', this.handleLinkClick.bind(this));
        document.removeEventListener('submit', this.handleFormSubmit.bind(this));
        // Restore original beforeunload handler
        if (this.originalBeforeUnloadHandler) {
            window.onbeforeunload = this.originalBeforeUnloadHandler;
        }
        // Remove any existing modal
        var existingModal = document.getElementById('navigation-warning-modal');
        if (existingModal) {
            existingModal.remove();
        }
    };
    return NavigationWarningService;
}());
exports.navigationWarningService = NavigationWarningService.getInstance();
